module.exports = __webpack_public_path__ + "img/transfer.57faedfd.svg";